import {
  admin_get_video_status,
  admin_end_video,
  admin_get_video_stream_details,
  admin_reset_show_status,
  admin_get_temp_recording,
  admin_get_stream_stats,
  end_streaming,
  admin_convert_to_vod,
} from "../../Common/data";
import React, { useState } from "react";
import { Modal, Typography, Box, List, ListItem, ListItemText } from "@mui/material";

const ModalContent = ({ data }) => {
  return  (
    <List>
      {Object.entries(data).map(([key, value]) => {
        const title = key.split('_').join(' ')
        return (
          <ListItem key={key} style={{ display: 'flex', borderBottom: '0.5px solid #95959d' }}>
            <ListItemText primary={title} style={{ maxWidth: '35%', textTransform: 'capitalize' }}/>
            <ListItemText primary={value} style={{ maxWidth: '65%' }}/>
          </ListItem>
        )
      })}
    </List>
  )
}


const AdminGeneral = () => {
  const [showID0, setShowID0] = useState();
  const [showID3, setshowID3] = useState();
  const [showID4, setshowID4] = useState();
  const [showID5, setshowID5] = useState();

  const [message, setMessage] = useState();
  const [EndVideoResult, seEndVideoResult] = useState();
  const [ShowStreamInfo, seShowStreamInfo] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null)
  const [convertToVODInput, setConvertToVODInput] = useState({})

  const handleInputChange = (e) => {
    setConvertToVODInput({
      ...convertToVODInput,
      [e.target.id]: e.target.value
    })
  }

  const handleModalOpen = () => {
    setModalOpen(true);
  };
  
  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleResetShowStatus = () => {
    const showId = {
      event_id: parseInt(showID0),
    };
    admin_reset_show_status(showId)
      .then((res) => setMessage("Show status reset successfully"))
      .catch(() => setMessage("Failed to reset show status"));
  };

  const handleEndShow = () => {
    const params = [{
      key: 'ShowID',
      value: showID3,
    }];
    end_streaming(params).then((result) => {
        if (result.code === "Success") {
            seEndVideoResult("Show ended successfully")
        }
        else {
            seEndVideoResult("Something went wrong")
        }
    }).catch(() => {
        seEndVideoResult("Failed to end show")
    })
  };

  const handleGetShowStreamDetails = () => {
    let data = {
      show_id: showID4,
    };

    admin_get_video_stream_details(data)
      .then((result) => {
        seShowStreamInfo(result.stream_info);
      })
      .catch(() => {
        seShowStreamInfo("Failed to get stream details");
      });
  };

  const getTempRecordings = () => {
    const payload = [{
      key: 'stream_id',
      value: showID5,
    }];
   
    admin_get_temp_recording(payload)
      .then((res) => {
        let { body } = res
        body = JSON.parse(body)
        if (body?.code === 'Success') {
          const data = body?.response[0]
          let payload = {}
          Object.keys(data).forEach(key => {
            if (typeof(data[key]) !== 'object') payload[key] = data[key]
          })
          handleModalOpen()
          setModalData({ title: 'Recording Data', data: payload })
        }
      })
      .catch((error) => setMessage("Failed to get recordings"));
  }

  const getShowStatistcs = () => {
    const payload = [{
      key: 'stream_id',
      value: showID0,
    }];

    admin_get_stream_stats(payload)
      .then((res) => {
        let { body } = res
        body = JSON.parse(body)
        if (body?.code === 'Success') {
          const data = body?.response[0]
          let payload = {}
          Object.keys(data).forEach(key => {
            if (typeof(data[key]) !== 'object') payload[key] = data[key]
          })
          handleModalOpen()
          setModalData({ title: 'Stream Statistics', data: payload })
        }
      })
      .catch(() => setMessage("Failed to get statistics"));
  }

  const handleConvertToVOD = async () => {
    let payload = [{
      key: 'stream_id',
      value: convertToVODInput.stream_id,
    }, {
      key: 'recording_id',
      value: convertToVODInput.recording_id,
    }];

    admin_get_temp_recording([{
      key: 'stream_id',
      value: convertToVODInput.stream_id
    }]).then((response) => {
      let { body } = response
      body = JSON.parse(body)
      if (body?.code === 'Success') {
        const data = body?.response[0]
        let recordingData = {}
        Object.keys(data).forEach(key => {
          if (typeof(data[key]) !== 'object') recordingData[key] = data[key]
        })
        if (recordingData.start_time) {
          payload = [
            ...payload,
            {
              key: 'from',
              value: recordingData.start_time,
            },
            {
              key: 'duration',
              value: recordingData.duration,
            }
          ]
        }
        admin_convert_to_vod(payload)
        .then(res => {
          let { body } = res
          body = JSON.parse(body)
          if (body?.code === 'Success') {
            const data = body?.response[0]
            let payload = {}
            Object.keys(data).forEach(key => {
              if (typeof(data[key]) !== 'object') payload[key] = data[key]
            })
            handleModalOpen()
            setModalData({ title: 'VOD Conversion', data: payload })
          }
        })
        .catch(() => setMessage("Failed to convert to VOD"))
      }
    }).catch(() => setMessage("Failed to get recording data"))
  }

  return (
    <div className="row adminRow">
      <h3>General Admin Actions</h3>
      <div className="col-md-12">
        <table className="table tableWhite">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Action</th>
              <th scope="col">Result</th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <td>Get Recordings</td>
              <td>
                <input
                  type="text"
                  id="recordingStreamId"
                  onChange={(e) => setshowID5(e.target.value)}
                  placeholder="Enter Stream ID Here"
                ></input>
                <button onClick={getTempRecordings} className="btn-primary">
                  Get
                </button>
              </td>
              <td colSpan="2">
                <small>{message}</small>
              </td>
            </tr>
            <tr>
              <td>Get Show Statistics</td>
              <td>
                <input
                  type="text"
                  id="statsStreamId"
                  onChange={(e) => setShowID0(e.target.value)}
                  placeholder="Enter Stream ID Here"
                ></input>
                <button onClick={getShowStatistcs} className="btn-primary">
                  Get
                </button>
              </td>
              <td colSpan="2">
                <small>{message}</small>
              </td>
            </tr>
            <tr>
              <td>Reset Event Status</td>
              <td>
                <input
                  type="text"
                  id="resetShowId"
                  onChange={(e) => setShowID0(e.target.value)}
                  placeholder="Enter Show ID Here"
                ></input>
                <button onClick={handleResetShowStatus} className="btn-primary">
                  Reset
                </button>
              </td>
              <td colSpan="2">
                <small>{message}</small>
              </td>
            </tr>
            <tr>
              <td>End video</td>
              <td>
                <input
                  type="text"
                  id="endShowId"
                  onChange={(e) => setshowID3(e.target.value)}
                  placeholder="Enter Show ID Here"
                ></input>
                <button onClick={handleEndShow} className="btn-primary">
                  End Video Stream
                </button>
              </td>
              <td>
                <small>{EndVideoResult}</small>
              </td>
            </tr>
            <tr>
              <td>Get Teder Show Stream Info</td>
              <td>
                <input
                  type="text"
                  id="streamInfoShowId"
                  onChange={(e) => setshowID4(e.target.value)}
                  placeholder="Enter Show ID Here"
                ></input>
                <button
                  onClick={handleGetShowStreamDetails}
                  className="btn-primary"
                >
                  Get Show Stream Info
                </button>
              </td>
              <td>
                <small>{ShowStreamInfo}</small>
              </td>
            </tr>
            <tr>
              <td>Convert Recording to VOD</td>
              <td>
                <input
                  type="text"
                  id="stream_id"
                  onChange={handleInputChange}
                  placeholder="Enter Stream ID Here"
                ></input>
                <input
                  type="text"
                  id="recording_id"
                  onChange={handleInputChange}
                  placeholder="Enter Recording ID Here"
                ></input>
                <button
                  onClick={handleConvertToVOD}
                  className="btn-primary"
                >
                  Convert To VOD
                </button>
              </td>
              <td>
                <small>{ShowStreamInfo}</small>
              </td>
            </tr>
          </tbody>
        </table>

        <Modal open={modalOpen} onClose={handleModalClose}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              boxShadow: 24,
              backgroundColor: '#1b194d',
              minWidth: '500px',
              p: 2,
            }}
          >
            <Typography variant="h6">{modalData?.title}</Typography>
            <ModalContent data={modalData?.data}/>
          </Box>
        </Modal>
    </div>
 </div>
  );
};

export default AdminGeneral;
